<template>
  <el-row class="core_one_wrap">
    <el-col class="one_left">
      <div class="left_tit">
        {{ core.subTitle }}
      </div>
      <ul class="left_desc">
        <li>
          {{ core.desc }}
        </li>
      </ul>
      <div class="left_card">
        <div class="card_item" v-for="(item, index) in core.children" :key="index">
          <span class="item_txt">{{ item }}</span>
        </div>
      </div>
    </el-col>
    <el-col class="one_right">
      <img :src="core.image" alt="">
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    core: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.core_one_wrap {
  display: flex;
  justify-content: center;
  text-align: left;
  margin-bottom: 30px;

  @media screen and (max-width: 768px) {
    margin-top: 25px;
    flex-wrap: wrap;
    padding: 0 10px;
    margin-bottom: 20px;
  }

  .one_left {
    width: 40%;
    padding: 20px 50px 20px 50px;

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-bottom: 15px;
    }

    .left_tit {
      font-size: 23px;
      font-weight: bold;
      color: #3e3e3e;

      @media screen and (max-width: 768px) {
        font-size: 1.4rem;
        margin-top: 10px;
        line-height: 1.4;
        padding: 0 5px;
      }
    }

    .left_desc {
      color: #717171;
      padding: 10px 40px 20px 40px;
      margin-top: 20px;

      li {
        line-height: 25PX;
      }

      @media screen and (max-width: 768px) {
        width: 88%;
        font-size: 14px;
        padding: 10px 5px 15px 5px;
        margin-top: 10px;
        margin-left: auto;
        margin-right: auto;
        line-height: 1.6;
      }
    }

    .left_card {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 25px;
      margin-right: 80px;

      @media screen and (max-width: 768px) {
        margin: 0;
        margin-top: 15px;
        gap: 8px;
        justify-content: space-between;
        padding: 0 5px;
      }

      .card_item {
        box-sizing: border-box;
        width: 30%;
        height: 50px;
        background: #fff;
        box-shadow: 0 -0.0625rem 0.4375rem 0 silver,
          0 0 0.75rem 0 rgb(0 0 0 / 10%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0991d3;
        padding: 0 20px;
        cursor: pointer;

        @media screen and (max-width: 768px) {
          height: 45px;
          width: 31%;
          border-radius: 6px;
          padding: 0 5px;
          box-shadow: 0 -0.0625rem 0.1875rem 0 silver, 0 0 0.25rem 0 rgb(0 0 0 / 6%);
        }

        i {
          font-size: 1.3rem;
        }

        &:nth-child(n + 4) {
          margin-top: 30px;

          @media screen and (max-width: 768px) {
            margin-top: 8px;
          }
        }

        &:nth-child(n + 7) {
          margin-top: 30px;

          @media screen and (max-width: 768px) {
            margin-top: 8px;
          }
        }

        &:hover .item_txt {
          letter-spacing: 4px;
        }

        .item_txt {
          width: 100%;
          font-weight: bold;
          font-size: 17px;
          margin-left: 10px;
          transition: all 1s;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: center;

          @media screen and (max-width: 768px) {
            font-size: 12px;
            margin-left: 0;
            letter-spacing: normal;
          }
        }
      }
    }
  }

  .one_right {
    width: 25%;
    height: 100%;

    @media screen and (max-width: 768px) {
      width: 90%;
      margin-top: 10px;
      display: flex;
      justify-content: center;
    }

    img {
      width: 100%;
      margin-top: 40px;

      @media screen and (max-width: 768px) {
        margin-top: 0;
        max-width: 320px;
        height: auto;
      }
    }
  }
}
</style>